import React from 'react';
import UnitRefNumbersPreview from './components/UnitRefNumbersPreview';

const headerData = [
  {
    label: 'proposal_id',
    input: 'proposalId',
  },
  {
    label: 'proposal_name',
    input: 'proposalName',
  },
  {
    label: 'property_name',
    input: 'propertyName',
  },
  {
    label: 'created_at',
    input: 'createdDate',
    isDate: true,
  },
  {
    label: 'template_type',
    input: 'templateType',
  },
  {
    label: 'template_mode',
    // input: 'templateMode',
    component: (row) =>
      row.templateType?.toLowerCase() !== 'classic' && row.templateMode,
  },
  {
    label: 'Unit Ref Num',
    component: (row) => <UnitRefNumbersPreview data={row} />,
  },
  {
    label: 'Platform',
    input: 'platformType',
  },
];

export default headerData;
